const Login = () => import(
  /* webpackChunkName: "login" */
  /* webpackMode: "lazy" */
  '@/views/login/login'
)

const PersonalCenter = () => import(
  /* webpackChunkName: "personal_center" */
  /* webpackMode: "lazy" */
  '@/views/personal-center/personal-center'
)

const PersonApprove = () => import(
  /* webpackChunkName: "personal_center" */
  /* webpackMode: "lazy" */
  '@/views/person-approve/person-approve'
)


// const Main = () => import(
//   /* webpackChunkName: "main" */
//   /* webpackMode: "lazy" */
//   '@/views/main/main'
// )

const SellerRegister = () => import(
  /* webpackChunkName: "seller-register" */
  /* webpackMode: "lazy" */
  '@/views/seller-register/seller-register'
)

const wxRedirect = () => import(
  /* webpackChunkName: "wxRedirect" */
  /* webpackMode: "lazy" */
  '@/views/wx-redirect/wxRedirect'
)

//  移动端注册登录
const Init = () => import(
  /* webpackChunkName: "mobileInit" */
  /* webpackMode: "lazy" */
  '@/views/mobile/init/init'
)
const MobileLogin = () => import(
  /* webpackChunkName: "mobileLogin" */
  /* webpackMode: "lazy" */
  '@/views/mobile/login/login'
)
const MobileRegister = () => import(
  /* webpackChunkName: "mobileRegister" */
  /* webpackMode: "lazy" */
  '@/views/mobile/register/register'
)

const WxBind = () => import(
  /* webpackChunkName: "mobileWxBind" */
  /* webpackMode: "lazy" */
  '@/views/mobile/wx-bind/wx-bind'
)

const LoginAuthorization = () => import(
	/* webpackChunkName: "loginAuthorization" */
  /* webpackMode: "lazy" */
  '@/views/login-authorization/index'
)

const SafetyRemind = () => import(
 /* webpackChunkName: "safetyRemind" */
 /* webpackMode: "lazy" */
 '@/views/safety-remind/index'
)

export default [{
  path: '/',
  redirect: '/login'
}, {
  path: '/login',
  component: Login,
  meta: {
    title: '登录'
  }
}, {
  path: '/personalCenter',
  component: PersonalCenter,
  meta: {
    title: '个人中心',
    auth: true
  }
}, {
  path: '/personApprove',
  component: PersonApprove,
  meta: {
    title: '实人认证',
    auth: true
  }
}, {
  path: '/sellerRegister',
  component: SellerRegister,
  meta: {
    title: '卖家注册',
    headTitle: '注册卖家身份',
    auth: true
  }
},{
  path: '/login-authorization',
  component: LoginAuthorization,
},{
  path: '/safety-remind',
  component: SafetyRemind,
}, {
  path: '/wxRedirect',
  component: wxRedirect
},{
  path: '/mobileInit', //  移动端初始化页面
  component: Init
},
{
  path: '/mobileLogin',  // 移动端登录
  component: MobileLogin
},{
  path: '/mobileRegister', // 移动端注册
  component: MobileRegister
},{
  path: '/wxBind', // 微信绑定
  component: WxBind
}]